import React from 'react';
import { segmentTrackEvent } from '../utils';

const Shop = ({
  subSection,
  type,
  isMobile,
  sectionIndex,
}) => {
  const {
    moduleType,
    title,
    items,
  } = subSection;

  const subhedClass = `sub-section-subhed ${type}-hed`;
  
  // modules within a section
  const renderedShoppableItems = items.map((item, i) => {
    const { label, itemImg, link } = item;
    const shopItemTracker = {
        destinationUrl: link,
        module: 'shop',
        category: 'open-kroger-shopping-link',
        linkType: 'open-kroger-shopping-link',
        label: `Shopping for ${label}`,
      };
    return (
        <>
            <li className='shoppable-item-wrapper'>
                <a className='item-img-wrapper' href={link} target="_blank" onClick={() => { segmentTrackEvent('shoppable item clicked', shopItemTracker); }}>
                    <img className='shoppable-img' src={itemImg} />
                    <h2 className='item-label'>{label}</h2>
                </a>
            </li>
        </>
    );
  });

  return (
    <>
        <div className="sub-section-copy">
            <div className="sub-section-copy-wrapper shop">
                <h3 className={subhedClass} dangerouslySetInnerHTML={{ __html: title }}></h3>
            </div>
        </div>
        <ul className='shoppable-items-container'>{renderedShoppableItems}</ul>
    </>
  );
};

export default Shop;
